import { render, staticRenderFns } from "./DeleteMetadataParameterDialog.vue?vue&type=template&id=55502d7a&"
import script from "./DeleteMetadataParameterDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteMetadataParameterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports